"use strict";Object.defineProperty(exports,"__esModule",{value:!0});let e={typescale:"MVP"},t=["VDS","MVP","Marketing"];var s={getTypescale:function(t){return e.typescale},settypescale:function(s){t.includes(s)&&(e.typescale=s)}};exports.default=s;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/calendars/~/@vds-core/typography/cjs/typographyConfig.js
// module id = 886
// module chunks = 0